import { useCallback } from 'react';

import { useInViewportOnce } from '@web-platform/shared-universal-utils-frontend/src/helpers/hooks/useInViewportOnce';
import { useDispatch } from 'react-redux';

import { advertVisible } from '../../actions/adverts';

const options: IntersectionObserverInit = {
  threshold: 0.5,
};
/**
 * Emits advertVisible event when advert is at least 50% in the viewport.
 * This allows to start loading Google Yolo without covering the main content of the advert.
 *
 * @returns {object} React ref to attach to the advert to be tracked
 */
export const useAdvertVisibilityTracking = () => {
  const dispatch = useDispatch();

  const onVisible = useCallback(() => {
    dispatch(advertVisible());
  }, [dispatch]);

  return useInViewportOnce(onVisible, options);
};
